import React from "react";
import { Linkedin } from "lucide-react";
import { useTranslation } from "react-i18next";

const TeamMember = ({
  name,
  title,
  image,
  description,
  linkedin,
  imagePosition = "object-top",
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="flex flex-col md:flex-row mb-16 bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-all duration-300 border-l-4 border-orange-500 hover:border-l-8">
      <div className="md:w-1/3 flex justify-center md:justify-start">
        <div className="w-48 h-48 rounded-full overflow-hidden border-4 border-orange-200">
          <img
            src={image}
            alt={t(name)}
            className={`w-full h-full object-cover ${imagePosition}`}
          />
        </div>
      </div>
      <div className="md:w-2/3 mt-4 md:mt-0 md:ml-6">
        <h2 className="text-2xl font-bold text-green-800">{t(name)}</h2>
        <p className="text-orange-600 mb-4">{t(title)}</p>
        <div className="prose prose-lg max-w-none">
          {t(description).split('\n\n').map((paragraph, index) => (
            <p key={index} className="mb-4 text-gray-700 leading-relaxed">{paragraph}</p>
          ))}
        </div>
        {linkedin && (
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-orange-500 hover:text-orange-600 inline-flex items-center mt-4 transition-colors duration-200"
          >
            <Linkedin size={24} className="mr-2" />
            <span>{t('team.leadership.connectLinkedIn')}</span>
          </a>
        )}
      </div>
    </div>
  );
};

const TeamPage = () => {
  const { t } = useTranslation();
  
  const teamMembers = [
    {
      name: "team.leadership.greg.name",
      title: "team.leadership.greg.title",
      image: "/images/GREG-2-240x300.jpg",
      description: "team.leadership.greg.description",
      linkedin: "https://www.linkedin.com/in/gregory-scott/",
    },
    {
      name: "team.leadership.millie.name",
      title: "team.leadership.millie.title",
      image: "/images/MILLIE-2-200x300.jpg",
      description: "team.leadership.millie.description",
      linkedin: "https://www.linkedin.com/in/milagros-gonzalez-scott/",
      imagePosition: "object-center",
    },
    {
      name: "team.leadership.liz.name",
      title: "team.leadership.liz.title",
      image: "/images/LIZ-2-200x300.jpg",
      description: "team.leadership.liz.description",
      linkedin: "https://www.linkedin.com/in/elizabeth-colon-camacho/",
    },
    {
      name: "team.leadership.agatha.name",
      title: "team.leadership.agatha.title",
      image: "/images/AGATHA-2-240x300.jpg",
      description: "team.leadership.agatha.description",
      linkedin: "https://www.linkedin.com/in/agatha-rijo/",
    },
    {
      name: "team.leadership.annise.name",
      title: "team.leadership.annise.title",
      image: "/images/ANISE-2-300x295.jpg",
      description: "team.leadership.annise.description",
      linkedin: "https://www.linkedin.com/in/annise-scott/",
    },
  ];

  return (
    <div className="bg-gradient-to-b from-green-50 to-orange-50 min-h-screen">
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-green-800 text-center mb-12">{t('team.title')}</h1>
        <div className="max-w-5xl mx-auto">
          {teamMembers.map((member, index) => (
            <TeamMember key={index} {...member} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
